<template>
  <div class="area-chart-container">
    <VueApexCharts
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
/* eslint-disable arrow-parens */
import _ from 'lodash';
import VueApexCharts from 'vue-apexcharts';
import numberUtils from '@/utils/numberUtils';

export default {
  mixins: [numberUtils],
  props: ['graphSeries', 'graphCategories'],
  components: {
    VueApexCharts,
  },
  watch: {
    graphSeries(series) {
      this.series = series;
    },
    graphCategories(categories) {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          xaxis: {
            categories,
          },
        },
      };
    },
  },
  computed: {
    isSeriesEmpty() {
      return _.isEmpty(this.graphSeries);
    },
    isCategoriesEmpty() {
      return _.isEmpty(this.categories);
    },
  },
  data() {
    return {
      categories: [],
      series: [],
      chartOptions: {
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: '<i class="fas fa-download"></i>',
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '65%',
            endingShape: 'flat',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          // type: 'category',
          categories: this.categories,
        },
        yaxis: {
          logarithmic: false,
          forceNiceScale: true,
          min: 0.75,
          tickAmount: 7,
          title: {
            text: '',
          },
          labels: {
            formatter: (value) => this.numberWithCommas(value),
          },
        },
        fill: {
          opacity: 1,
          colors: '#4CAFE1',
        },
        tooltip: {
          y: {
            formatter: (value) => this.numberWithCommas(value),
            title: {
              formatter: () => '',
            },
          },
        },
        responsive: [
          {
            breakpoint: 1100,
            options: {
              yaxis: {
                logarithmic: false,
                forceNiceScale: true,
                min: 0.75,
                tickAmount: 5,
                title: {
                  text: '',
                },
                labels: {
                  formatter: (value) => this.abbreviateLongNumbers(value),
                },
              },
            },
          },
          {
            breakpoint: 576,
            options: {
              yaxis: {
                logarithmic: false,
                forceNiceScale: true,
                min: 0.75,
                tickAmount: 4,
                title: {
                  text: '',
                },
                labels: {
                  formatter: (value) => this.abbreviateLongNumbers(value),
                },
              },
            },
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
